
if (!customElements.get('l-section-ask-designer')) {
	customElements.define(
		'l-section-ask-designer',
		class LCustomSectionAskDesigner extends HTMLElement {
			constructor() {
				super()

        this.sectionId = this.dataset.sectionId

        this.triggerBtns = this.querySelectorAll('[data-popup-open]')
        this.popupForm = document.getElementById(`AskDesigner-${this.sectionId}`)

        if (!this.popupForm) return

        this.triggerBtns.forEach(triggerBtn => {
          triggerBtn.addEventListener('click', () => {
            this.popupForm.classList.add('is-active')
          })
        })

        this.popupForm.querySelector('[data-close-btn]').addEventListener('click', () => {
          this.popupForm.classList.remove('is-active')
        })
			}
		}
	)
}
